import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import qs from 'qs'
import { getNextPageParam } from 'utils/getNextPageParam'
import { Response } from 'request-dot-js/index'
import { reportError } from 'utils/error'
import { ChatThread } from 'api/clients/ChatClient'
import { chatKeys } from './chatKeys'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

interface Data {
  threads: ChatThread[]
}

export interface ThreadsData {
  pages: Array<Response<Data>>
  pageParams: unknown[]
}

interface Params {
  page: number
  items: number
  almanac_file_id?: string
}

interface Props extends Partial<Pick<Params, 'items'>> {
  fileId?: string
}

const fetchThreads = async (workspaceId: number, params: Params) => {
  const stringifiedParams = qs.stringify(params)
  const res = await sendToApi<Data>(`/w/${workspaceId}/threads?${stringifiedParams}`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res
}

export const useInfiniteThreads = (
  { items = 10, fileId }: Props,
  options?: UseInfiniteQueryOptions<Response<Data>>,
) => {
  const workspaceId = useCurrentWorkspaceId()

  return useInfiniteQuery<Response<Data>>(
    chatKeys.threads(workspaceId, { fileId, items }),
    ({ pageParam = 1 }) => {
      return fetchThreads(workspaceId, { page: pageParam, items, almanac_file_id: fileId })
    },
    {
      refetchOnWindowFocus: false,
      getNextPageParam,
      onError: (err) => {
        reportError(err, {
          severity: 'error',
        })
      },
      ...options,
    },
  )
}
